/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateTagRequest interface.
 */
export function instanceOfUpdateTagRequest(value) {
    if (!('keyValue' in value) || value['keyValue'] === undefined)
        return false;
    return true;
}
export function UpdateTagRequestFromJSON(json) {
    return UpdateTagRequestFromJSONTyped(json, false);
}
export function UpdateTagRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keyValue': json['keyValue'],
    };
}
export function UpdateTagRequestToJSON(json) {
    return UpdateTagRequestToJSONTyped(json, false);
}
export function UpdateTagRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'keyValue': value['keyValue'],
    };
}
